const SOLUTION_BANNERS = {
  enterprise: require('@/assets/Solution/Enterprise-banner.webp'),
  artificial: require('@/assets/Solution/Artificial-banner.webp'),
  carrier: require('@/assets/Solution/Carrier-banner.webp'),
  educational: require('@/assets/Solution/Educational-banner.webp'),
  internet: require('@/assets/Solution/Internet-banner.webp'),
  manufacturing: require('@/assets/Solution/Manufacturing-banner.webp'),
};

const KEYWORD_RULES = [
  { keywords: ['企业', '政企', 'enterprise'], key: 'enterprise' },
  { keywords: ['人工智能', 'artificial', 'ai'], key: 'artificial' },
  { keywords: ['运营商', 'carrier', '电信'], key: 'carrier' },
  { keywords: ['教育', 'educational'], key: 'educational' },
  { keywords: ['互联网', 'internet'], key: 'internet' },
  { keywords: ['制造', 'manufacturing', '工业'], key: 'manufacturing' },
];

export const DEFAULT_SOLUTION_BANNER = SOLUTION_BANNERS.enterprise;

/** 按分类名称匹配 @/assets/Solution 下的 banner */
export const getSolutionBanner = (name = '') => {
  const text = String(name).toLowerCase();
  for (const { keywords, key } of KEYWORD_RULES) {
    if (keywords.some((k) => text.includes(k.toLowerCase()) || String(name).includes(k))) {
      return SOLUTION_BANNERS[key];
    }
  }
  return DEFAULT_SOLUTION_BANNER;
};
